<template>
  <div class="col-lg-3 col-sm-12 color-dashboard-background grid_combo_left">
    <div class="food-menu_container" v-if="comboItemsList">
      <div
        class="food-menu_title"
        v-for="(item, index) in comboItemsList.combo_items"
        :class="{ active_left_combo: index === activeItem }"
        :key="index"
        @click="setActiveItem(index, item)"
      >
        {{ _T_DB(item, 'name') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  data() {
    return {
      activeItem: 0,
    }
  },
  name: 'Items',
  watch: {
    activeComboItems() {
      this.$nextTick(() => {
        this.activeItem = 0
      })
    },
  },
  computed: {
    ...mapState('combo_items_store', ['comboItemsList', 'activeComboItems']),
    ...mapGetters(['_T_DB']),
  },
  methods: {
    setActiveItem(itemIndex, itemList) {
      if (this.activeItem != itemIndex) {
        this.activeItem = itemIndex
        this.$store.commit('combo_items_store/SET_SELECTED_ITEM_DATA', itemList)
        this.$store.dispatch('combo_items_store/findItemById')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.grid_combo_left {
  padding: 0 $px8;
}
.food-menu_container {
  display: grid;
  grid-template-rows: 1fr;
  grid-row-gap: 0.625rem;
  position: relative;
  .food-menu_title {
    display: block;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    font-size: $px14;
    line-height: $px22;
    letter-spacing: 0.5px;
    font-weight: 600;
    border-radius: $px4;
    padding: $px8 $px28;
    background: $white;
    color: $color-primary;
    border: $px1 solid $color-primary;
    transition: all 0.5s ease;
    &:hover {
      background: $color-primary;
      color: $white;
      transition: all 0.3s ease-in-out;
    }
    &.active_left_combo {
      background: $color-primary;
      color: $white;
      /*border-right: 1rem solid red;*/
    }
  }
}
@media (max-width: 991px) {
  .food-menu_container{
    display: flex;
    margin-bottom: $px20;
    .food-menu_title{
      margin-right: $px10;
    }
  }
}
</style>
